import React from "react";
import { Routes, Route } from 'react-router-dom';
import AuthLayout from './_auth/AuthLayout';
import RootLayout from './_root/RootLayout';
import Auth from './_auth/forms/Auth';
import { Home, Profile, Friends } from './_root/pages';
import Followers from "./_root/pages/Followers";
import Followings from "./_root/pages/Followings";
import SavePost from "./_root/pages/SavePost";
import Notifications from "./_root/pages/Notifications";
import AccountSettings from "./_root/pages/AccountSettings";
import ResetPassword from "./_auth/ResetPassword";
import { Toaster } from "react-hot-toast";
import BackgroundUploads from "./components/BackgroundUploads";

function App() {
  return (
    <main className="h-screen">
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/auth" element={<Auth />}/>
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        
        <Route element={<RootLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/friends" element={<Friends />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/followers" element={<Followers />} />
          <Route path="/followings" element={<Followings />} /> 
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/saved" element={<SavePost />} />
          <Route path="/settings/account" element={<AccountSettings />} />
        </Route>
      </Routes>

      <Toaster position="top-right" reverseOrder={false} duration={60000} />
      <BackgroundUploads />
    </main>
  );
}

export default App;
